import CheckoutLayout from "@/components/layouts/checkout-layout";
import { renderCheckoutView } from "@/components/templates/Checkout/templates/render-checkout-view";
import { Locales } from "@/lib/i18n";
import { cn } from "@/lib/utils";
import { actions } from "@/locales/segment";
import { notFound } from "next/navigation";

type CheckoutProps = {
  resolution: Resolution;
};

export const isEventInfoRoute = (locale: Locales, slug: string) => {
  const localeActions = actions[locale as keyof typeof actions];
  if (!localeActions) return false;
  return localeActions["event-info"] === slug;
};

export const isCustomerInfoRoute = (locale: Locales, slug: string) => {
  const localeActions = actions[locale as keyof typeof actions];
  if (!localeActions) return false;
  return localeActions["customer-info"] === slug;
};

export const isDeliveryRoute = (locale: Locales, slug: string) => {
  const localeActions = actions[locale as keyof typeof actions];
  if (!localeActions) return false;
  return localeActions["delivery"] === slug;
};

export const isRecapRoute = (locale: Locales, slug: string) => {
  const localeActions = actions[locale as keyof typeof actions];
  if (!localeActions) return false;
  return localeActions["recap"] === slug;
};

export const isThankYouRoute = (locale: Locales, slug: string) => {
  const localeActions = actions[locale as keyof typeof actions];
  if (!localeActions) return false;
  return localeActions["thank-you"] === slug;
};

const Checkout = ({ resolution }: CheckoutProps) => {
  const [route] = resolution.slugs;

  const viewComponent = renderCheckoutView(resolution);

  if (viewComponent === null) return notFound();

  return (
    <CheckoutLayout
      className={cn(isRecapRoute(resolution.locale, route) && "lg:flex-col xl:flex-row")}
      showBackButton={
        isEventInfoRoute(resolution.locale, route) || isThankYouRoute(resolution.locale, route) ? false : true
      }
      route={route}
      locale={resolution.locale}
    >
      {viewComponent}
    </CheckoutLayout>
  );
};

export default Checkout;
